import { Flex, ProgressBar as LemonadeProgressBar } from '@percent/lemonade'
import { ProgressBarProps } from './ProgressBar.types'
import styles from './ProgressBar.module.scss'

export function ProgressBar({ progress }: ProgressBarProps) {
  if (progress === undefined) {
    return null
  }

  return (
    <Flex className={styles.progressBar}>
      <LemonadeProgressBar
        progressPercentage={progress}
        backgroundColorComplete="primary400"
        backgroundColorIncomplete="primary400"
        shadeColor="gray90"
        sizeVariant="x-small"
        enableAnimation
      />
    </Flex>
  )
}
